/**
 * -------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation.  All Rights Reserved.  Licensed under the MIT License.
 * See License in the project root for license information.
 * -------------------------------------------------------------------------------------------
 */
export const strings = {
    contactSectionTitle: 'Contact',
    emailTitle: 'Email',
    chatTitle: 'Teams',
    businessPhoneTitle: 'Business Phone',
    cellPhoneTitle: 'Mobile Phone',
    departmentTitle: 'Department',
    titleTitle: 'Title',
    officeLocationTitle: 'Office Location',
    copyToClipboardButton: 'Copy to clipboard'
};
//# sourceMappingURL=strings.js.map